import CardActions from './card-actions';
import Image from '@/components/image';

function ProductCard({ product, fromDetails, mage }) {
  return (
    <div className='mb-6 flex items-center justify-start gap-3 md:gap-6'>
      <Image
        src={`${process.env.NEXT_PUBLIC_IMG_BASEURL}/catalog/product/${product?.extension_attributes?.product_image}`}
        alt={product.name}
        width={100}
        height={100}
        className='rounded-lg'
        objectFit='contain'
      />
      <div className='flex w-full flex-col'>
        <p className='line-clamp-2 text-sm md:text-base'>{product.name}</p>
        <div className='mt-6 flex flex-col items-start justify-between gap-2 md:flex-row'>
          <p className='text-sm font-semibold md:text-base'>
            <span className='text-primary'>{product.qty_ordered} × </span>
            {product.price_incl_tax} SR
          </p>
          {fromDetails && <CardActions product={product} mage={mage} />}
        </div>
      </div>
    </div>
  );
}

export default ProductCard;
